import { HttpHandler } from 'msw'

import { getStock } from './getStock'

export const stockReports: HttpHandler[] = [getStock]
